import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../ControlInputContainer';
import { generateDataTestId } from '../../utils';
import { useInputSize } from '../../hooks';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент radio/checkbox похожего на прозрачную кнопку
 *
 * @export
 * @param {IControlButtonProps} props
 * @returns
 */
export var ControlButton = /*#__PURE__*/React.forwardRef(function ControlButton(props, ref) {
  var disabled = props.disabled,
    invalid = props.invalid,
    label = props.label,
    sizeProp = props.size,
    dataTestId = props.dataTestId;
  var size = useInputSize(sizeProp);
  var styles = React.useMemo(function () {
    return getStyles(size);
  }, [size]);
  return /*#__PURE__*/_jsx(ControlInputContainer, _objectSpread(_objectSpread({}, props), {}, {
    className: clsx(styles['control-button'], disabled && styles['disabled'], invalid && styles['invalid']),
    ref: ref,
    children: /*#__PURE__*/_jsx("span", {
      className: clsx(styles['button']),
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    })
  }));
});